import { render, staticRenderFns } from "./GroupMessageBoard.vue?vue&type=template&id=073ea500&scoped=true"
import script from "./GroupMessageBoard.vue?vue&type=script&lang=js"
export * from "./GroupMessageBoard.vue?vue&type=script&lang=js"
import style0 from "./GroupMessageBoard.vue?vue&type=style&index=0&id=073ea500&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073ea500",
  null
  
)

export default component.exports